import { Dispatch, RefObject } from "react";
import { react } from "uikit";

import DinarPaymentsCurrency from "./components/DinarPaymentsCurrency";
import DinarPaymentsCountryIso from "./components/DinarPaymentsCountryIso";

interface Context {
	dinarPayPassword: string;
	dinarPayUsername: string;
	dinarPayApiUrl: string;
	currencyRef: RefObject<DinarPaymentsCurrency.Ref | null>;
	countryIsoRef: RefObject<DinarPaymentsCountryIso.Ref | null>;
	setDinarPayUsernameError: Dispatch<boolean>;
	setDinarPayPasswordError: Dispatch<boolean>;
	setDinarPayApiUrlError: Dispatch<boolean>;
}

export default class Controller extends react.ControllerBase<Context> {
	validate() {
		const isCurrency = this.context?.currencyRef.current?.validate();
		const isCountryIso = this.context?.countryIsoRef.current?.validate();
		const isDinarPayPassword = !!this.context?.dinarPayPassword.trim();
		const isDinarPayUsername = !!this.context?.dinarPayUsername.trim();

		if (!isDinarPayUsername) {
			this.context?.setDinarPayUsernameError(true);
		}

		if (!isDinarPayPassword) {
			this.context?.setDinarPayPasswordError(true);
		}

		return [
			isCurrency,
			isCountryIso,
			isDinarPayUsername,
			isDinarPayPassword,
		].every((isValid) => isValid);
	}
}
